import gql from 'graphql-tag';
import store from '@/store';

function getGqlString (doc) {
  return doc.loc && doc.loc.source.body;
}

function getGraphqlSchema (filename, project) {
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const query = require(`./${filename}.graphql`);

    return gql(getGqlString(query).replaceAll('_PROJECT_', project || store.state.environment.PROJECT).replaceAll('_PROJECTTYPE_', store.state.environment.PROJECT_TYPE));
  } catch (error) {
    console.log('ERROR READING GRAPHQL SCHEMAS -> ', error);
    return error;
  }
}

export { getGraphqlSchema };
